import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";

interface IFormEditarCodProposta {
  codProposta: string;
  setCodProposta: React.Dispatch<React.SetStateAction<string>>;
}

export const FormEditarCodProposta = ({
  codProposta,
  setCodProposta,
}: IFormEditarCodProposta) => {
  return (
    <AppTextField
      label="Proposta *"
      sxStyle={{ width: "100%", opacity: "", pointerEvents: "auto", margin: 0 }}
      tooltip="Código de proposta deve ser único"
      value={codProposta}
      onChange={(e) => setCodProposta(e.target.value)}
      variant="outlined"
    />
  );
};
